/**
 * An enumeration of all the clause types used within DAS.
 */
export enum DASClauseType {
  HEADING = 'HEADING',
  SUB_HEADING = 'SUB_HEADING',
  NORMAL = 'NORMAL',
  ATTACHMENT = 'ATTACHMENT',
  LOCATION = 'LOCATION',
  INFORMATION = 'INFORMATION',
  CONDITION = 'CONDITION',
  LINKED_DEPARTURE = 'LINKED_DEPARTURE',
}
